let makeCurrency = (val, curr = "₽") => `${val} ${curr}`;
// const patternEmail = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i;
// const patternEmail = /^[A-Za-z0-9_\-\.]+(?<!\.)@[A-Za-z0-9_-]+\.[A-Za-z]{2,}(?![a-zA-Z])$/;
const patternEmailWithCyrillic = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
//const patternEmail = /^\w+([-.]\w+)*@\w+([-.])*\w+\.[A-Za-z]+$/i;

function formatPhone(phone) {
  if (!phone) return;
  const phoneDigits = phone.replace(/\D/g, "");
  if (phoneDigits.length !== 11) return phone;
  return phoneDigits.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, "+$1 ($2) $3-$4-$5");
}

function validateInn(inn) {
  let valid = false;
  if (inn.length === 10) {
    const sum = [2, 4, 10, 3, 5, 9, 4, 6, 8].reduce((res, n, i) => res + n * inn[i], 0);
    valid = parseInt((sum % 11) % 10) === parseInt(inn[9]);
  }
  if (inn.length === 12) {
    const sum11 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8].reduce((res, n, i) => res + n * inn[i], 0);
    const sum12 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8].reduce((res, n, i) => res + n * inn[i], 0);

    valid = parseInt((sum11 % 11) % 10) === parseInt(inn[10]) && parseInt((sum12 % 11) % 10) === parseInt(inn[11]);
  }
  return valid;
}

function validateOgrn(ogrn) {
  let valid = false;
  if (ogrn.length === 13) {
    const control = parseInt((parseInt(ogrn.slice(0, -1)) % 11).toString().slice(-1));
    valid = control === parseInt(ogrn[12]);
  }
  if (ogrn.length === 15) {
    const control = parseInt((parseInt(ogrn.slice(0, -1)) % 13).toString().slice(-1));
    valid = control === parseInt(ogrn[14]);
  }
  return valid;
}

function validateAcc(acc, bic) {
  let valid = false;
  if (acc && acc.length === 20 && bic) {
    const factors = [7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1];
    const bicAcc = bic.slice(-3) + acc;
    const check = factors.reduce((sum, n, i) => sum + n * (bicAcc[i] % 10), 0);
    valid = check % 10 === 0;
  }
  return valid;
}

function validateSnils(snils) {
  let valid = false;
  if (snils && snils.length === 11) {
    const sum = [9, 8, 7, 6, 5, 4, 3, 2, 1].reduce((sum, n, i) => sum + n * snils[i], 0);
    let checkSum = 0;

    if (sum < 100) {
      checkSum = sum;
    } else if (sum > 101) {
      checkSum = parseInt(sum % 101);

      if (checkSum === 100) {
        checkSum = 0;
      }
    }

    if (checkSum === parseInt(snils.slice(-2))) {
      valid = true;
    }
  }
  return valid;
}

function generatePass(length) {
  const digits = "0123456789";
  const upper = "QWERTYUIOPASDFGHJKLZXCVBNM";
  const lower = "qwertyuiopasdfghjklzxcvbnm";
  const letters = digits + lower + upper;
  const max_position = letters.length - 1;
  let result = "";

  if (!length) length = 12;
  for (let i = 0; i < length; ++i) {
    const position = Math.floor(Math.random() * max_position);
    result += letters.substring(position, position + 1);
  }

  if (!/[A..Z]/.test(result)) {
    const pos = Math.floor(Math.random() * (upper.length - 1));
    result += upper.substring(pos, pos + 1);
  }

  if (!/[a..z]/.test(result)) {
    const pos = Math.floor(Math.random() * (lower.length - 1));
    result += lower.substring(pos, pos + 1);
  }

  if (!/[\d]/.test(result)) {
    const pos = Math.floor(Math.random() * (digits.length - 1));
    result += digits.substring(pos, pos + 1);
  }

  return result;
}

function formatDate(str) {
  if (!str) return null;

  const [year, month, day] = str.split("-");
  return `${day}.${month}.${year}`;
}

function unformatDate(str) {
  if (!str) return null;

  const [day, month, year] = str.split(".");
  return `${year}-${month}-${day}`;
}

function slotsTime(slots) {
  const reducer = (accumulator, current) => {
    let date = current.start.split("T")[0];

    if (!(date in accumulator)) {
      accumulator[date] = [];
    }
    accumulator[date].push(current);

    return accumulator;
  };

  return slots.reduce(reducer, {});
}

function isDigit(value) {
  let isDigit = !/\D/.test(value);
  return isDigit;
}

/**
 * Plural forms for russian words
 * @param  {Integer} count quantity for word
 * @param  {Array} words Array of words. Example: ['депутат', 'депутата', 'депутатов'], ['коментарий', 'коментария', 'комментариев']
 * @return {String}        Count + plural form for word
 */
 function pluralize(count, words) {
  var cases = [2, 0, 1, 1, 1, 2];
  return count + ' ' + words[ (count % 100 > 4 && count % 100 < 20) ? 2 : cases[ Math.min(count % 10, 5)] ];
}

export {
  makeCurrency,
  formatPhone,
  validateInn,
  validateOgrn,
  validateAcc,
  validateSnils,
  generatePass,
  patternEmailWithCyrillic,
  formatDate,
  unformatDate,
  slotsTime,
  isDigit,
  pluralize
};
